var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-button',{staticClass:"mt-0",attrs:{"data-test":"btn-complete-payment","loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.$t('general.complete_payment'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }